import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DEVELOPMENT, getEnvironmentType, STAGING, ROUTES } from '@cyberint/common-utils';
import { CustomTooltip } from '@cyberint/dsc';
import * as S from './styled';

const STG_REG_EXP = /[a-zA-Z0-9_-]+\.staging\.cyberint\.io/;

const resolveWatermark = server => {
  const type = getEnvironmentType();
  if (type === STAGING) return { label: 'Staging' };
  if (type === DEVELOPMENT) return { label: 'Dev', suffix: server && (STG_REG_EXP.test(server) ? 'Stg' : 'Prod') };
  return null;
};

export const WaterMarkBase = ({ server, className }) => {
  const [isClosed, setIsClosed] = useState(false);
  if (isClosed || window.argosParams?.[ROUTES.HIDE_WATERMARK]) return null;
  const watermark = resolveWatermark(server);
  if (!watermark) return null;

  return (
    <S.WaterMark className={className}>
      {watermark.suffix ? (
        <>
          <span>{watermark.label}</span>
          <CustomTooltip title={server}>
            <span className="env-value">&nbsp;({watermark.suffix})</span>
          </CustomTooltip>
        </>
      ) : (
        watermark.label
      )}
      <S.CloseButton onClick={() => setIsClosed(true)} />
    </S.WaterMark>
  );
};

WaterMarkBase.propTypes = {
  server: PropTypes.string,
  className: PropTypes.string
};
